
import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    cancel: "Annuler",
    specialtyTitle: "Spécialité :",
    address: "Adresse :",
    phoneNumber: "Numéro de téléphone :"
};

export type _I18nBookingUserCard = typeof _fr;

const _en: _I18nBookingUserCard = {
    cancel: "Cancel",
    specialtyTitle: "Specialty :",
    address: "Address :",
    phoneNumber: "Phone number :"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nBookingUserCard(lang?: string): _I18nBookingUserCard {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}